// extracted by mini-css-extract-plugin
export default {"spinner":"Bvzvf__spinner","timer":"j4rEc__timer","stopBtn":"HWf_G__stopBtn"};